// @flow
import package_json from "../../../package.json";

import {
  CHANGE_LAYOUT,
  CHANGE_LAYOUT_WIDTH,
  CHANGE_SIDEBAR_THEME,
  CHANGE_SIDEBAR_TYPE,
  CHANGE_TOPBAR_THEME,
  CHANGE_MAIN_THEME,
  TOGGLE_RIGHT_SIDEBAR,
  SHOW_RIGHT_SIDEBAR,
  CHANGE_PRELOADER,
  HIDE_RIGHT_SIDEBAR,
  CHAT_EXPANDING,
  CHAT_COLLAPSE,
  CHANGE_HEADER_NAME,
} from "./actionTypes";

const mainThemeStore = localStorage.mainTheme;

const INIT_STATE = {
  layoutType: "vertical",
  layoutWidth: "fluid",
  leftSideBarTheme: "dark",
  leftSideBarType: "icon",
  topbarTheme: "light",
  mainTheme: mainThemeStore ?? "dark",
  isPreloader: false,
  showRightSidebar: false,
  isMobile: false,
  chatExpanded: false,
  headerName: "",
  version: package_json.version,
};

const Layout = (state = INIT_STATE, action) => {
  switch (action.type) {
    case CHANGE_LAYOUT:
      return {
        ...state,
        layoutType: action.payload,
      };
    case CHANGE_PRELOADER:
      return {
        ...state,
        isPreloader: action.payload,
      };

    case CHANGE_LAYOUT_WIDTH:
      return {
        ...state,
        layoutWidth: action.payload,
      };
    case CHANGE_SIDEBAR_THEME:
      return {
        ...state,
        leftSideBarTheme: action.payload,
      };
    case CHANGE_SIDEBAR_TYPE:
      return {
        ...state,
        leftSideBarType: action.payload.sidebarType,
      };
    case CHANGE_TOPBAR_THEME:
      return {
        ...state,
        topbarTheme: action.payload,
      };
    case CHANGE_MAIN_THEME:
      return {
        ...state,
        mainTheme: action.payload,
        oldTheme: state.mainTheme,
      };
    case TOGGLE_RIGHT_SIDEBAR:
      return {
        ...state,
        showRightSidebar: !state.showRightSidebar,
      };
    case SHOW_RIGHT_SIDEBAR:
      return {
        ...state,
        showRightSidebar: true,
      };
    case HIDE_RIGHT_SIDEBAR:
      return {
        ...state,
        showRightSidebar: false,
      };
    case CHAT_EXPANDING:
      return {
        ...state,
        chatExpanded: true,
      };
    case CHAT_COLLAPSE:
      return {
        ...state,
        chatExpanded: false,
      };
    case CHANGE_HEADER_NAME:
      return {
        ...state,
        headerName: action.payload,
      };
    default:
      return state;
  }
};

export default Layout;
